import React, { useEffect, useRef } from "react";
const MessagesInjector = ({ id, locale, messages }) => {
  const firstRender = useRef(true);
  useEffect(() => {
    firstRender.current = false;
  }, []);
  return firstRender.current ? /* @__PURE__ */ React.createElement("script", {
    "data-testid": `${id}-messages-script`,
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: `
      window.translations = window.translations || {};
      window.translations["${id}"] = {
        locale: "${locale}",
        messages: ${JSON.stringify(messages.read())},
      };
  `
    }
  }) : null;
};
var MessagesInjector_default = MessagesInjector;
export {
  MessagesInjector_default as default
};
